// extracted by mini-css-extract-plugin
export default {"feedBack":"button_feedBack__queUM"};